import React, { useEffect, useState } from 'react';

const API_URL = "https://v6d18bgl57.execute-api.us-west-1.amazonaws.com/prod/admin-logs";

const LogViewer = ({ user }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, admin, stripe

  useEffect(() => {
    const token = user?.signInUserSession?.idToken?.jwtToken;
    if (!token) {
      console.error("No JWT token available");
      setLoading(false);
      return;
    }

    fetch(API_URL, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        setLogs(data.logs || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("❌ Failed to load logs:", err);
        setLoading(false);
      });
  }, [user]);

  const filteredLogs = logs.filter(log => {
    if (filter === 'all') return true;
    if (filter === 'admin') return log.event_type !== 'stripe_webhook';
    if (filter === 'stripe') return log.event_type === 'stripe_webhook';
    return true;
  });

  const getEventBadge = (log) => {
    if (log.event_type === 'stripe_webhook') {
      const badgeColors = {
        'checkout.session.completed': 'success',
        'customer.subscription.deleted': 'danger',
        'invoice.payment_failed': 'warning'
      };
      const color = badgeColors[log.stripe_event_type] || 'secondary';
      return (
        <span className={`badge bg-${color}`}>
          {log.stripe_event_type || 'Stripe Event'}
        </span>
      );
    }
    return <span className="badge bg-info">Admin Action</span>;
  };

  return (
    <div className="container mt-4">
      <h2>Audit Logs</h2>

      <div className="mb-3">
        <div className="btn-group" role="group">
          <button
            className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('all')}
          >
            All Logs
          </button>
          <button
            className={`btn btn-sm ${filter === 'admin' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('admin')}
          >
            Admin Actions
          </button>
          <button
            className={`btn btn-sm ${filter === 'stripe' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('stripe')}
          >
            Stripe Events
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading logs...</p>
      ) : (
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Time</th>
              <th>Event</th>
              <th>User</th>
              <th>Plan Change</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((log, i) => (
              <tr key={i}>
                <td>{new Date(log.timestamp).toLocaleString()}</td>
                <td>{getEventBadge(log)}</td>
                <td>{log.target_email || log.admin_email || 'N/A'}</td>
                <td>
                  {(log.old_plan || log.previous_plan) && (log.new_plan) ?
                    `${log.old_plan || log.previous_plan} → ${log.new_plan}` :
                    'N/A'
                  }
                </td>
                <td>
                  {log.event_type === 'stripe_webhook' && log.metadata ? (
                    <button
                      className="btn btn-sm btn-link"
                      onClick={() => {
                        const metadata = JSON.parse(log.metadata);
                        console.log('Metadata:', metadata);
                        alert(JSON.stringify(metadata, null, 2));
                      }}
                    >
                      View Details
                    </button>
                  ) : (
                    log.action || 'N/A'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LogViewer;
